import type { TooltipComponentOption } from "echarts";
import type { EChartsOption } from "echarts-for-react";

export const commonProperties: Partial<EChartsOption> = {
  grid: { left: 70, right: 40, bottom: 20, top: -5 },
  aria: {
    enabled: true,
  },
  yAxis: {
    axisLabel: {
      showMinLabel: false,
    },
    splitNumber: 3,
  },
  xAxis: {
    type: "category",
    data: [],
  },
};
export const tooltip: TooltipComponentOption = {
  trigger: "axis",
  axisPointer: {
    type: "none",
  },
  className: "balance-tooltip",
};

export const labelOption = {
  show: false,
};
